import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import TripsList from "@/pages/TripsList";
import TripWizard from "@/pages/TripWizard";
import TripDetail from "@/pages/TripDetail";
import CompanyCars from "@/pages/CompanyCars";
import Users from "@/pages/Users";
import Bookings from "@/pages/Bookings";
import AiAssistant from "@/pages/AiAssistant";
import PrintItinerary from "@/pages/PrintItinerary";
import TeamCalendar from "@/pages/TeamCalendar";
import ChangePassword from "@/pages/ChangePassword";

function Protected({ children }) {
  return <ProtectedRoute>{children}</ProtectedRoute>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/trasferte" element={<Protected><TripsList /></Protected>} />
            <Route path="/nuova-trasferta" element={<Protected><TripWizard /></Protected>} />
            <Route path="/trasferte/:id" element={<Protected><TripDetail /></Protected>} />
            <Route path="/trasferte/:id/modifica" element={<Protected><TripWizard /></Protected>} />
            <Route path="/trasferte/:id/stampa" element={<Protected><PrintItinerary /></Protected>} />
            <Route path="/prenotazioni" element={<Protected><Bookings /></Protected>} />
            <Route path="/calendario-team" element={<Protected><TeamCalendar /></Protected>} />
            <Route path="/auto-aziendali" element={<Protected><CompanyCars /></Protected>} />
            <Route path="/utenti" element={<Protected><Users /></Protected>} />
            <Route path="/assistente-ai" element={<Protected><AiAssistant /></Protected>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
